function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M230 282v205c0 13 12 25 26 25s26-11 26-25V282h205c13 0 25-12 25-26s-11-26-25-26H282V25c0-13-12-25-26-25s-26 11-26 25v205H25c-13 0-25 12-25 26s11 26 25 26z"
});
function SvgCreateNewPost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "create-new-post_svg__icon",
    viewBox: "0 0 512 512",
    height: "1em",
    width: "1em",
    fill: "currentColor"
  }, props), _ref);
}
export default __webpack_public_path__ + "fonts/create-new-post-f835f69b6373a6e6bc92059bdc97c3e0.svg";
export { SvgCreateNewPost as ReactComponent };